<template>
	<div class="bg-color-granite pb-10">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="About RISE" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-dell-blue tx-color-white">
                <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                    <v-row no-gutters>
                        <LanguagePlaceholder default-text='The RISE Incentive Program rewards you for purchasing eligible Dell Technologies products with competitive $-per-box rewards, multipliers, and bonuses - giving you the chance to earn up to $15,000 in rewards per incentive period.' />
                    </v-row>
                    <v-row no-gutters class="pt-10 tx-font-normal tx-font-size18">
                        <v-icon icon="mdi-play-circle-outline" size="x-large" class="pb-2 tx-font-normal"></v-icon>
                        <LanguagePlaceholder is-html default-text='<a href="https://vimeo.com/1060226066/4b0a40239c" class="dell-white">WATCH</a>: the RISE overview video.'></LanguagePlaceholder>
                    </v-row>              
                </v-col>
                </v-row>
            </div>
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <h1>
                        <LanguagePlaceholder default-text='How to earn rewards with RISE'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white d-flex justify-center w-100 pa-0 tx-font-bold">  
                    <div class="bg-color-white tx-font-bolder ma-0 pa-0">
                        <v-row>
                            <v-col cols="10" class="pa-10">
                                <strong>
                                <LanguagePlaceholder default-text='Core rewards'></LanguagePlaceholder>
                                </strong>
                                <p class="tx-font-bold pb-5">
                                <LanguagePlaceholder default-text='These rewards are earned and logged automatically the moment you purchase a RISE eligible product from a Dell Technologies Authorized Distributor—no reporting needed, we take care of the details for you!'></LanguagePlaceholder>
                                </p>
                                <strong>
                                <LanguagePlaceholder default-text='Multipliers'></LanguagePlaceholder>
                                </strong>
                                <p class="tx-font-bold pb-5">
                                <LanguagePlaceholder default-text='Core rewards can be multiplied by up to 1.6x when specific unit thresholds are reached.'></LanguagePlaceholder>
                                </p>
                                <strong>
                                <LanguagePlaceholder default-text='Bonuses'></LanguagePlaceholder>
                                </strong>
                                <p class="tx-font-bold pb-3">
                                <LanguagePlaceholder 
                                    is-html 
                                    default-text="Discover additional earning opportunities with RISE bonuses. Visit the <route route-name='bonus-dashboard-partner' style='text-decoration: underline;'>Bonus Dashboard</route> to see which bonuses you've qualified for.">
                                </LanguagePlaceholder>
                                </p>
                            </v-col>
                            <v-col cols="2" class="ma-0 pa-0 mt-3 d-flex justify-center align-center bg-color-mist" style="overflow: hidden;">
                                    <v-img
                                        :width="180"
                                        :height="180"
                                        src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/1.6X.png"
                                    ></v-img>
                            </v-col>
                        </v-row>                        
                    </div>            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <h1>
                        <LanguagePlaceholder default-text='How to multiply your rewards'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-center w-100 pa-0 tx-font-bold">  
                    <div class="bg-color-white tx-font-bolder pa-10 pb-12">
                        <p class="tx-font-bold pb-10">
                        <LanguagePlaceholder default-text='When you achieve specific thresholds, your rewards will be multiplied by up to 1.6x. Thresholds are independently calculated for each product category. For example, you can achieve your PC+ threshold and receive up to 1.6x your PC+ rewards without needing to meet the unit thresholds for Server+ or Storage+.'></LanguagePlaceholder>
                        </p>
                        <v-row>
                        <v-col cols="1" class="bg-color-glacier d-flex justify-center align-center">
                            <v-img
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/iconPeripherals.png"
                            ></v-img>
                        </v-col>
                        <v-col cols="4" style="border-left: 1px solid #C8C9C7;" class="d-flex justify-center align-start flex-column bg-color-sky tx-color-white">
                            <p class="tx-font-bolder tx-font-size18">
                                <LanguagePlaceholder default-text='PCS+ DISPLAYS+PERIPHERALS'></LanguagePlaceholder>
                            </p>
                            <p class="tx-font-normal tx-font-size14">
                                <LanguagePlaceholder default-text="PCs, Displays and Client Peripheral units bought as SnS"></LanguagePlaceholder>
                            </p>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                            <v-col>
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='0 - 29 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-dell-blue bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-dell-blue bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='30 - 79 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-cobalt bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.2x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-cobalt bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='80 - 249 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-royal bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.3x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-royal bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='250 - 399 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-navy bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.5x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-navy bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='400+ Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-midnight bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.6x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-midnight bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            </v-row>
                        </v-col>
                        </v-row>

                        <v-row class="ma-0 pa-0" style="height: 10px;">
                        <v-col cols="1" class="ml-16 mt-n2">
                            <v-img style="height: 20px;" class="ml-5"
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/OR.png"
                            ></v-img>
                        </v-col>
                        <v-col cols="4"></v-col>
                        <v-col cols="7"></v-col>
                        </v-row>

                        <v-row class="mt-2">
                        <v-col cols="1" class="bg-color-glacier d-flex justify-center align-center">
                            <v-img
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/iconServer.png"
                            ></v-img>
                        </v-col>
                        <v-col cols="4" style="border-left: 1px solid #C8C9C7;" class="d-flex justify-center align-start flex-column bg-color-cornflower tx-color-white">
                            <strong>
                            </strong>
                            <p class="tx-font-normal">
                            </p>
                            <p class="tx-font-bolder tx-font-size18">
                                <LanguagePlaceholder default-text='SERVER+'></LanguagePlaceholder>
                            </p>
                            <p class="tx-font-normal tx-font-size14">
                                <LanguagePlaceholder default-text="Server units bought as SnS or B2B Smart Selection Offers"></LanguagePlaceholder>
                            </p>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                            <v-col>
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='0 - 4 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-dell-blue bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-dell-blue bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='5 - 9 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-cobalt bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.2x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-cobalt bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='10 - 14 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-royal bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.3x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-royal bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='15 - 19 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-navy bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.5x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-navy bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='20+ Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-midnight bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.6x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-midnight bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            </v-row>
                        </v-col>
                        </v-row>

                        <v-row class="ma-0 pa-0" style="height: 10px;">
                        <v-col cols="1" class="ml-16 mt-n2">
                            <v-img style="height: 20px;" class="ml-5"
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/OR.png"
                            ></v-img>
                        </v-col>
                        <v-col cols="4"></v-col>
                        <v-col cols="7"></v-col>
                        </v-row>

                        <v-row class="mt-2">
                        <v-col cols="1" class="bg-color-glacier d-flex justify-center align-center">
                            <v-img
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/iconStorage.png"
                            ></v-img>
                        </v-col>
                        <v-col cols="4" style="border-left: 1px solid #C8C9C7;" class="d-flex justify-center align-start flex-column bg-color-dell-blue tx-color-white">
                            <strong>
                            </strong>
                            <p class="tx-font-normal">
                            </p>
                            <p class="tx-font-bolder tx-font-size18">
                                <LanguagePlaceholder default-text='STORAGE+'></LanguagePlaceholder>
                            </p>
                            <p class="tx-font-normal tx-font-size14">
                                <LanguagePlaceholder default-text="Storage B2B Smart Selection Offers"></LanguagePlaceholder>
                            </p>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                            <v-col>
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='1 Unit'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-dell-blue bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-dell-blue bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='2 - 3 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-cobalt bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.2x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-cobalt bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='4 - 7 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-royal bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.3x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-royal bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='8 - 11 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-navy bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.5x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-navy bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='12+ Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-midnight bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.6x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-midnight bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            </v-row>
                        </v-col>
                        </v-row>
                        <p class="tx-font-bold pt-10">
                        <LanguagePlaceholder default-text='Only PC hardware units (laptops, desktops and workstations) count towards your PCs+Displays+Peripherals reward multiplier thresholds (displays and peripherals do not). Once thresholds have been achieved, the rewards multiplier is applied to all products purchased within this category, including accessories.'></LanguagePlaceholder>
                        </p>
                    </div>            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <h1>
                        <LanguagePlaceholder default-text='How your rewards are paid'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-quartz d-flex justify-center w-100 pa-0 pb-10 tx-font-bold">  
                    <div class="bg-color-white tx-font-bolder w-100 h-100 mb-5">
                        <v-row>
                        <v-col cols="10" class="pl-8 pt-10 mb-0 pb-0">
                            <strong>
                            <LanguagePlaceholder default-text='At the end of each incentive period, your rewards will be calculated and paid out in credit notes or e-vouchers*.'></LanguagePlaceholder>
                            </strong>
                            <div class="d-flex">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<p>1.</p>&nbsp;&nbsp;&nbsp;
                            <p class="tx-font-bold pb-2">
                                <LanguagePlaceholder default-text='If you earn $5,000 or more in the incentive period, you will receive a credit note to spend with your Dell Technologies Authorized Distributor.'></LanguagePlaceholder>
                            </p>
                            </div>
                            <div class="d-flex">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<p>2.</p>&nbsp;&nbsp;&nbsp;
                            <p class="tx-font-bold pb-2">
                                <LanguagePlaceholder default-text='If you earn less than $5,000, you will be able to exchange your RISE rewards for e-vouchers you can spend with your Dell Technologies Authorized Distributor.'></LanguagePlaceholder>
                            </p>
                            </div>
                            <div class="d-flex justify-center align-center pa-5 ma-2 bg-color-cornflower tx-color-white tx-font-normal w-25">
                            <LanguagePlaceholder is-html default-text='<a href="https://dellpartnerincentives.com/files/Acquisitions/Partner%20Presentation/RISE%20Partner%20Introductory%20Guide%20EN.pdf" class="dell-white">Click here</a> for more information.'></LanguagePlaceholder>
                            </div>    
                            <div class="d-flex justify-start align-center pa-3 ma-2 pl-0 tx-color-royal tx-font-normal tx-font-bold">
                            <LanguagePlaceholder is-html default-text='* Please note, certain countries are paid via credit note only for local legislative reasons. The full list of countries can be found <a href="https://dellpartnerincentives.com/resources/RISE%20Program%20-%20META%20Countries%20paid%20via%20Passthrough%20Credit%20Notes%20(002).pdf">here</a>.'></LanguagePlaceholder>
                            </div>  
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                            <div class="w-100 h-100 my-2 pt-1" style="overflow: hidden;">
                                <v-img cover class="h-100"
                                :width="150"
                                :height="180"
                                src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/$5000(Blue).gif"
                                ></v-img>
                            </div>
                        </v-col>
                        </v-row>                
                    </div>            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
            </div>
            <div class="bg-color-cobalt tx-color-white w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 pt-10 tx-font-bold">  
                    <h1>
                        <LanguagePlaceholder default-text='Step by step guide'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 pb-10 bg-color-cobalt tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 tx-font-bold">  
                        <v-card>
                            <v-tabs v-model="tab" grow color="#1D65C0">
                                <v-tab class="text-none bg-color-glacier tx-color-white" :value="1">
                                    <LanguagePlaceholder 
                                    default-text="1. Purchase" />
                                </v-tab>
                                <v-tab class="text-none bg-color-mist tx-color-white" :value="2">
                                    <LanguagePlaceholder 
                                    default-text="2. Earn Rewards" />
                                </v-tab>
                                <v-tab class="text-none bg-color-pool tx-color-white" :value="3">
                                    <LanguagePlaceholder 
                                    default-text="3. Grow Rewards" />
                                    </v-tab>
                                <v-tab class="text-none bg-color-sky tx-color-white" :value="4">
                                    <LanguagePlaceholder 
                                    default-text="4. Spend Rewards" />
                                    </v-tab>
                            </v-tabs>
                            <v-tabs-window v-model="tab">
                                <v-tabs-window-item :value="1">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-navy tx-font-normal pa-5 pb-0">
                                                <strong class="tx-color-navy tx-font-bold">
                                                    <LanguagePlaceholder default-text='Earn $ rewards for purchasing RISE eligible products from participating Authorized Distributors.'></LanguagePlaceholder>
                                                </strong>
                                            </div>
                                        </v-card-text>
                                        <div class="tx-color-white px-10 pb-5 pt-2">
                                            <v-btn class="text-none bg-color-dell-blue" @click="systemStore.routerTo('home-eligible-products')">
                                                <LanguagePlaceholder default-text="View Eligible Products" />
                                            </v-btn>  
                                        </div>
                                    </v-card>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="2">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-navy tx-font-normal pa-5 pb-0">
                                                <strong class="tx-color-navy tx-font-bold">
                                                    <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="Your $ rewards will accumulate throughout the 13-week incentive period."></LanguagePlaceholder>
                                                    </p>
                                                    <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="There's no need to report your purchases. Simply order and your purchases are automatically logged."></LanguagePlaceholder>
                                                    </p>
                                                    <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="Track how much you have earned using your 'My Performance' report."></LanguagePlaceholder>
                                                    </p>
                                                </strong>
                                            </div>
                                        </v-card-text>
                                        <div class="tx-color-white px-10 pb-5">
                                            <v-btn class="text-none bg-color-dell-blue" @click="systemStore.routerTo('my-performance')">
                                                <LanguagePlaceholder default-text="My Performance" />
                                            </v-btn>  
                                        </div>
                                    </v-card>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="3">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-navy tx-font-normal pa-5 pb-0">
                                                <strong class="tx-color-navy tx-font-bold">
                                                    <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="Core rewards can be multiplied by up to 1.6x when specific unit thresholds are reached."></LanguagePlaceholder>
                                                    </p>
                                                    <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="You can also maximise your earnings with RISE bonuses—updated each incentive period."></LanguagePlaceholder>
                                                    </p>
                                                </strong>
                                            </div>
                                        </v-card-text>
                                        <div class="tx-color-white px-10 pb-5">
                                            <v-btn class="text-none bg-color-dell-blue" @click="systemStore.routerTo('bonus-dashboard-partner')">
                                                <LanguagePlaceholder default-text="Bonus Dashboard" />
                                            </v-btn>  
                                        </div>
                                    </v-card>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="4">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-navy tx-font-normal pa-5 pb-0">
                                                <strong class="tx-color-navy tx-font-bold">
                                                    <LanguagePlaceholder default-text='At the start of the next incentive period, your rewards will be calculated and paid out in the following two ways:'></LanguagePlaceholder>
                                                </strong>
                                                <br><br>
                                                <strong class="tx-color-navy tx-font-bolder">
                                                    <LanguagePlaceholder default-text="If you earn $5,000 or more in the incentive period, your rewards will be paid via credit note." />
                                                </strong>
                                                <br>
                                                <LanguagePlaceholder default-text="At the end of the incentive period, your rewards will be calculated and credit notes will be issued to the Dell Technologies Authorized Distributors you have purchased from throughout the previous incentive period. They will be sent the credit note(s) to apply to your future orders." />
                                                <br><br>
                                                <strong class="tx-color-navy tx-font-bolder">
                                                    <LanguagePlaceholder default-text="If you earn less than $5,000 in the incentive period, your rewards will earn e-vouchers." />
                                                </strong>
                                                <br>
                                                <LanguagePlaceholder default-text="You will be able to exchange your RISE rewards for distributor e-vouchers. You can decide which Dell Technologies Authorized Distributors you would like to receive e-vouchers for." />
                                            </div>
                                        </v-card-text>
                                        <div class="tx-color-white px-10 pb-5 pt-2">
                                            <v-btn class="text-none bg-color-dell-blue" @click="systemStore.routerTo('redemption')">
                                                <LanguagePlaceholder default-text="Redeem My Rewards" />
                                            </v-btn>  
                                        </div>
                                    </v-card>
                                </v-tabs-window-item>
                            </v-tabs-window>
                        </v-card>
                    </v-col>
                </v-row>
            </div>     
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()

const tab = ref(null)

</script>

<style scoped>

</style>